import PropTypes from 'prop-types';
// @mui
import { Stack, Typography } from '@mui/material';
import Iconify from '../iconify';

// ----------------------------------------------------------------------

export default function ItemNotFound({ title }) {
    return (
        <Stack
            alignItems="center"
            sx={{ my: 1, opacity: .4 }}
            spacing={1}
        >
            <Iconify icon="mdi:receipt-text-remove" width={60}/>

            <Typography variant="body2" fontSize={{ xs: 12, md: 16 }} textTransform="uppercase">
                {title}
            </Typography>
        </Stack>
    );
}

ItemNotFound.propTypes = {
    title: PropTypes.string,
};